(function basicThankYouModal() {
  'use strict';

  /**
   * Toggles the visibility of a modal element by adding or removing the 'hidden' attribute.
   * @param {HTMLElement} modal - The modal element to toggle.
   */
  function toggleModal(modal) {
    modal.toggleAttribute('hidden');
  }

  /**
   * Attaches events to the thank you modal element.
   * @function
   * @returns {void}
   */
  function bindEvents() {
    const thankYouModal = document.querySelector('[data-basic-thank-you-modal]');
    const createAccountButton = thankYouModal.querySelector('[data-create-account]');

    if (createAccountButton) {
      // if the user clicks the create account button, trigger the Auth0 sign in.
      createAccountButton.addEventListener('click', () => {
        if (window.auth0Dom) {
          window.auth0Dom.signIn();
        }
      });
    }
  }

  /**
   * Shows the thank you modal and binds its events.
   */
  function showThankYouModal() {
    const thankYouModal = document.querySelector('[data-basic-thank-you-modal]');

    bindEvents();
    toggleModal(thankYouModal);
  }

  document.body.addEventListener('showThankYouModal', showThankYouModal);
}());
